class HHCartEvents extends HTMLElement {
  constructor() {
    super()
    this.handleDrawer = this.handleDrawer.bind(this);
  }
  connectedCallback() {
    window.addEventListener('drawer:opened', this.handleDrawer);
  }

  disconnectedCallback() {
    window.removeEventListener('drawer:opened', this.handleDrawer)
  }

  handleDrawer(e) {
    if (e.detail.id === 'mini-cart') {
      const dataElement = this.querySelector('#cart-data');
      if (dataElement) {
        const data = JSON.parse(dataElement.innerHTML);
        Shopify.analytics.publish('mini_cart_viewed', data);
      }
    }
  }
}
customElements.define('hh-cart-events', HHCartEvents);
